/* eslint-disable @typescript-eslint/no-explicit-any */
import { isObject } from "@/utils/typeGuard";
import type { AxiosError } from "axios";
import type {
  DefaultOptions,
  UseMutationOptions,
  UseQueryOptions,
} from "react-query";
import { QueryClient } from "react-query";
import type { FetchError } from "./fetchClient";

const queryConfig: DefaultOptions = {
  queries: {
    useErrorBoundary: (error) => {
      const isNetworkError =
        isObject(error) && "code" in error && error?.["code"] === "ERR_NETWORK";
      const isPollingQuery =
        isObject(error) &&
        "meta" in error &&
        isObject(error["meta"]) &&
        error?.["meta"]?.["isPolling"] === true;
      return !isNetworkError || !isPollingQuery;
    },
    refetchOnWindowFocus: false,
    retry: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });

export type ExtractFnReturnType<FnType extends (...args: any[]) => any> =
  Awaited<ReturnType<FnType>>;

export type QueryConfig<QueryFnType extends (...args: any[]) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  "queryKey" | "queryFn"
>;

export type MutationConfig<MutationFnType extends (...args: any[]) => any> =
  UseMutationOptions<
    ExtractFnReturnType<MutationFnType>,
    // TODO: openapi-fetch への移行が完了したら AxiosError を削除する
    AxiosError | FetchError,
    Parameters<MutationFnType>[0]
  >;
